/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterY = createReactComponent("letter-y", "IconLetterY", [
  ["path", { d: "M7 4l5 9l5 -9", key: "svg-0" }],
  ["path", { d: "M12 13l0 7", key: "svg-1" }]
]);

export { IconLetterY as default };
//# sourceMappingURL=IconLetterY.js.map
